import { css, keyframes } from 'styled-components';

export const ellipsis = css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

const DEFAULT_PULSE_DURATION = 1200;

export const pulseAnimation = keyframes`
    from {
        background-position: 0% 0%;
    }

    to {
        background-position: -135% 0%;
    }
`;

export const pulseStyle = css<{ $duration?: number }>`
    animation: ${ ({ $duration = DEFAULT_PULSE_DURATION }) => css`${ pulseAnimation } ${ $duration }ms ease-in-out infinite` };
    background-color: ${ props => props.theme.color.grey.grey_10 };
    background: linear-gradient(
        -90deg,
        ${ props => props.theme.color.grey.grey_10 } 0%,
        ${ props => props.theme.color.grey.grey_0 } 50%,
        ${ props => props.theme.color.grey.grey_10 } 100%
    );
    background-size: 400% 400%;
`;
